import React, { useState } from 'react';

export default function ConversionFunnel({
  bookings = 0,
  dutySlips = 0,
  invoices = 0
}) {
  const currentBookings = Number(bookings) || 0;
  const currentDutySlips = Number(dutySlips) || 0;
  const currentInvoices = Number(invoices) || 0;

  const bNum = currentBookings;
  const dsNum = currentDutySlips;
  const invNum = currentInvoices;

  const dsPct = bNum > 0 ? Math.round((dsNum / bNum) * 100) : (dsNum > 0 ? 100 : 0);
  const invPct = bNum > 0 ? Math.round((invNum / bNum) * 100) : (dsNum > 0 ? Math.round((invNum / dsNum) * 100) : 0);

  return (
    <div className="dash-card p-2 d-flex flex-column justify-content-between" style={{ height: '100%', minHeight: 260 }}>
      {/* Top Header */}
      <div className="d-flex justify-content-between align-items-center mb-1 px-1">
        <div>
          <h6 className="m-0 fw-bold" style={{ fontSize: '12.5px', color: '#0f172a' }}>
            Workflow Conversion
          </h6>
          <span style={{ fontSize: '10px', color: '#64748b', fontWeight: '500' }}>
            Booking &rarr; Duty Slip &rarr; Invoicing
          </span>
        </div>

        <div>
          <span
            className="badge"
            style={{
              fontSize: '10px',
              fontWeight: '600',
              backgroundColor: '#eff6ff',
              color: '#1d4ed8',
              border: '1px solid #bfdbfe',
              padding: '2px 7px',
              borderRadius: '4px'
            }}
          >
            {invPct}% Final Conversion
          </span>
        </div>
      </div>

      {/* Large Prominent 3-Tier Funnel filling container nicely */}
      <div className="d-flex align-items-center justify-content-center flex-grow-1 w-100 py-1" style={{ minHeight: 210 }}>
        <svg viewBox="0 0 370 200" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" style={{ maxHeight: '230px', overflow: 'visible' }}>
          <defs>
            <linearGradient id="funnelTier1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0a665c" />
              <stop offset="100%" stopColor="#064e48" />
            </linearGradient>
            <linearGradient id="funnelTier2" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#129a8e" />
              <stop offset="100%" stopColor="#0d7a71" />
            </linearGradient>
            <linearGradient id="funnelTier3" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#15803d" />
              <stop offset="100%" stopColor="#0d5a2b" />
            </linearGradient>
            <filter id="funnelShadow" x="-10%" y="-10%" width="120%" height="130%">
              <feDropShadow dx="0" dy="2" stdDeviation="2.5" floodOpacity="0.2" />
            </filter>
          </defs>

          {/* Tier 1: Bookings Received */}
          <path
            d="M 15 6 L 275 6 L 250 64 L 40 64 Z"
            fill="url(#funnelTier1)"
            filter="url(#funnelShadow)"
          />
          <text x="145" y="27" fill="#ffffff" fontSize="10.5" fontWeight="600" textAnchor="middle" opacity="0.95">
            1. Bookings Received
          </text>
          <text x="145" y="52" fill="#ffffff" fontSize="20" fontWeight="800" textAnchor="middle">
            {bNum}
          </text>
          {/* Tier 1 Arrow */}
          <circle cx="262" cy="35" r="3.5" fill="#64748b" />
          <line x1="266" y1="35" x2="312" y2="35" stroke="#cbd5e1" strokeWidth="1.5" strokeDasharray="3 3" />
          <text x="320" y="39" fill="#64748b" fontSize="12" fontWeight="700">
            100%
          </text>

          {/* Tier 2: Duty Slips Generated */}
          <path
            d="M 40 70 L 250 70 L 225 128 L 65 128 Z"
            fill="url(#funnelTier2)"
            filter="url(#funnelShadow)"
          />
          <text x="145" y="91" fill="#ffffff" fontSize="10.5" fontWeight="600" textAnchor="middle" opacity="0.95">
            2. Duty Slips Generated
          </text>
          <text x="145" y="116" fill="#ffffff" fontSize="20" fontWeight="800" textAnchor="middle">
            {dsNum}
          </text>
          {/* Tier 2 Arrow */}
          <circle cx="237" cy="99" r="3.5" fill="#0d7a71" />
          <line x1="241" y1="99" x2="312" y2="99" stroke="#0d7a71" strokeWidth="1.5" strokeDasharray="3 3" />
          <text x="320" y="103" fill="#0d7a71" fontSize="12" fontWeight="700">
            {dsPct}%
          </text>

          {/* Tier 3: Invoices Dispatched */}
          <path
            d="M 65 134 L 225 134 L 200 192 L 90 192 Z"
            fill="url(#funnelTier3)"
            filter="url(#funnelShadow)"
          />
          <text x="145" y="155" fill="#ffffff" fontSize="10.5" fontWeight="600" textAnchor="middle" opacity="0.95">
            3. Invoices Dispatched
          </text>
          <text x="145" y="180" fill="#ffffff" fontSize="20" fontWeight="800" textAnchor="middle">
            {invNum}
          </text>
          {/* Tier 3 Arrow */}
          <circle cx="212" cy="163" r="3.5" fill="#15803d" />
          <line x1="216" y1="163" x2="312" y2="163" stroke="#15803d" strokeWidth="1.5" strokeDasharray="3 3" />
          <text x="320" y="167" fill="#15803d" fontSize="12" fontWeight="700">
            {invPct}%
          </text>
        </svg>
      </div>
    </div>
  );
}
